<div class="wrapper--spacing-horizontal print-only">
  <div class="avoid-page-break">
    @if (customer$ | async) {
      <agr-value-row [label]="reportForLabel | translate">{{
        (customer$ | async)?.name
      }}</agr-value-row>
      <agr-value-row [label]="'address' | translate"
        >{{ (customer$ | async)?.street }} {{ (customer$ | async)?.houseNumber }}
        {{ (customer$ | async)?.houseNumberAddition }}
      </agr-value-row>
      <agr-value-row [label]="'city' | translate"
        >{{ (customer$ | async)?.postalCode }} {{ (customer$ | async)?.city }}
      </agr-value-row>
      <agr-value-row [label]="'mobile' | translate">{{
        (customer$ | async)?.mobileNumber
      }}</agr-value-row>
      <agr-value-row [label]="'telephone' | translate">{{
        (customer$ | async)?.phoneNumber
      }}</agr-value-row>
      <agr-value-row [label]="'email' | translate">{{
        (customer$ | async)?.emailAddress
      }}</agr-value-row>
    }
  </div>
</div>
